import { computedFrom } from "aurelia-binding";
import { autoinject, transient } from "aurelia-dependency-injection";
import { AssignBuRuleCollectionsRequest } from "../../../../../../../models/rules/rules.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../../services/basics/notification-client.service";
import { RulesClientService } from "../../../../../../../services/rules/rules-client.service";
import { DataGrid } from "../../../../../../components/data-grid/data-grid";
import { BusinessUnitAddRuleCollectionsDialogModel } from "../business-unit-add-rule-collections-dialog";

@autoinject
@transient()
export class LinkRuleCollectionsToBuDialog
{
    isInternal: boolean = false;
    ruleCollectionPrompt: string = "";
    businessUnitId: number;
    dataGrid: DataGrid;

    ruleCollections: {name:string, displayName:string, ruleCollectionId:number}[] = [];
    filteredRuleCollections: {name: string, displayName: string, ruleCollectionId: number}[] = [];
    selectedRuleCollections: {name: string, displayName: string, ruleCollectionId: number, businessUnitId: number }[] = [];

    _search: string;
    set search(x: string) {
        this._search = x;
        this.filterItemSource();
    }

    @computedFrom("_search")
    get search() {
        return this._search;
    }

    onSubmit: () => void;

    constructor(private rulesClientService: RulesClientService, private dialogClientSerivice: DialogClientService, private notificationClientSerivice: NotificationClientService){}

    async activate(model: BusinessUnitAddRuleCollectionsDialogModel)
    {
        this.businessUnitId = model.businessUnitId;
        this.dataGrid = model.dataGrid;
        this.ruleCollections = await this.rulesClientService.getAvailableRuleCollections(this.businessUnitId);
        this.onSubmit = model.onSubmit;
        this.filterItemSource();
    }

    submit(): Promise<void> {
        return new Promise((resolve, reject) => {
            const request: AssignBuRuleCollectionsRequest = {
                businessUnitId: this.businessUnitId,
                assignedRuleCollectionIds: this.selectedRuleCollections.map(x => x.ruleCollectionId),
                isInternal: this.isInternal,
                ruleCollectionPrompt: this.ruleCollectionPrompt
            };
            this.rulesClientService.assignBuRuleCollections(request).then(() => {
                this.notificationClientSerivice.show("Success", "Rule collections assigned successfully", NotificationType.Success);
                if (this.dataGrid) {
                    this.dataGrid.reloadData();
                }
                this.close();
                if(this.onSubmit)
                    this.onSubmit();
                resolve();
            }).catch(e => {
                this.notificationClientSerivice.show("Failed", "Failed  to assign rule collections", NotificationType.Error);
                reject(e);
            });
        });
    }

    dispose(): void {
    }

    filterItemSource() {
        if (this.search) {
            this.filteredRuleCollections = this.ruleCollections.filter(x => (x.displayName && x.displayName.toLowerCase().indexOf(this.search.toLowerCase()) > -1) || (x.name && x.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1));
        }
        else {
            this.filteredRuleCollections = this.ruleCollections;
        }

        const selectedRuleCollectionIds = this.selectedRuleCollections.map(x => x.ruleCollectionId);
        this.filteredRuleCollections = this.filteredRuleCollections.filter(x => selectedRuleCollectionIds.indexOf(x.ruleCollectionId) == -1);
    }

    addRuleCollection(rc: {ruleCollectionId:number, displayName:string, name:string}){
        this.selectedRuleCollections.push({
            ruleCollectionId: rc.ruleCollectionId,
            displayName: rc.displayName,
            name: rc.name,
            businessUnitId: this.businessUnitId
        });
        this.filterItemSource();
    }

    removeRuleCollection(index:number){
        this.selectedRuleCollections.splice(index,1);
        this.filterItemSource();
    }

    close()
    {
        this.dialogClientSerivice.hide();
    }

}